export default "__VITE_ASSET__CJxg_QIe__"